import classNames from 'classnames';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import Size from '../../types/size';

type Props = {
  className?: string;
  cmsComponentKey?: string;
  properties?: {
    vertical_margin?: string;
    horizontal_margin?: string;
  };
  style?: React.CSSProperties;
  testId?: string;
};

const Container: FC<Props> = ({
  cmsComponentKey,
  properties = { vertical_margin: Size.middle, horizontal_margin: Size.middle },
  children,
  className,
  style,
  testId
}) => {
  return (
    <section
      data-testid={testId ?? `wid-home-collection-${cmsComponentKey}`}
      data-module={cmsComponentKey}
      style={style}
      className={twMerge(
        classNames(
          {
            'my-2': properties?.vertical_margin === Size.small,
            'my-3': properties?.vertical_margin === Size.middle,
            'my-4': properties?.vertical_margin === Size.large
          },
          className
        )
      )}>
      {children}
    </section>
  );
};

export default Container;
